import { Illustration, PageHeaderWrapper, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { SupportContext } from "@src/appV2/support/constants";
import { HowToContactSupportLink } from "@src/appV2/support/HowToContactSupportLink";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { PageHeaderTopRow } from "../../components/PageHeaderTopRow";
import { PageWrapper } from "../../components/PageWrapper";

export function DocumentsNoShiftsPage() {
  const history = useHistory();

  return (
    <PageWrapper variant="tertiary">
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow />
      </PageHeaderWrapper>

      <Stack
        direction="column"
        spacing={10}
        sx={{
          padding: 5,
          flex: 1,
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack spacing={7} alignItems="center">
          <Illustration type="info" />
          <Text variant="h4">
            There are no workplaces in your area that have recently posted shifts
          </Text>

          <Button
            onClick={() => {
              history.push(DeprecatedGlobalAppV1Paths.ADDRESS);
            }}
          >
            Click here to change your address
          </Button>
        </Stack>

        <Stack spacing={3} alignItems="center">
          <Text>If you keep having trouble, please reach out to our Support team.</Text>

          <HowToContactSupportLink supportContext={SupportContext.DOCUMENTS_ERROR} />
        </Stack>
      </Stack>
    </PageWrapper>
  );
}
